import React, { useContext, useState, useEffect } from "react";
import ProductsTab from "../../views/ProductsTab/ProductsTab";
import { AppContext } from "../../store/AppContext";
import CategoriesTab from "../../views/CategoriesTab/CategoriesTab";
import OrdersTab from "../../views/OrdersTab/OrdersTab";
import DashboardTab from "../../views/Dashboard/DashboardTab";
import CustomersTab from "../../views/CustomersTab/CustomersTab";
import CouponsTab from "../../views/CouponsTab/CouponsTab";
import CustomerEngagementTab from "../../views/CustomerEngagementTab/CustomerEngagementTab";

const Contents = () => {
  const { selectedTab, isCollapsed, isMobileSidebarOpen } =
    useContext(AppContext);
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size and update mobile state
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  console.log(selectedTab, "========>selectedTab");

  // Calculate content width based on device and sidebar state
  const getContentWidth = () => {
    if (isMobile) {
      return "100%";
    }
    return isCollapsed ? "calc(100% - 80px)" : "calc(100% - 250px)";
  };

  // Calculate content left position
  const getContentLeft = () => {
    if (isMobile) {
      return "0";
    }
    return isCollapsed ? "80px" : "250px";
  };

  // Calculate top position (accounting for header)
  const getContentTop = () => {
    return "8vh"; // Same as header height
  };

  // Render content based on selected tab and subtab
  const renderContent = () => {
    const categoryTitle = selectedTab?.category?.title;
    const subCategoryTitle = selectedTab?.subCategory?.title;

    // Dashboard
    if (categoryTitle === "Dashboard") {
      return <DashboardTab />;
    }

    // Orders
    if (categoryTitle === "Orders") {
      return <OrdersTab />;
    }

    // Products - check for subcategory
    if (categoryTitle === "Products") {
      if (subCategoryTitle === "Categories") {
        return <CategoriesTab />;
      }
      // Default to All products
      return <ProductsTab />;
    }

    // Customers
    if (categoryTitle === "Customers") {
      return <CustomersTab />;
    }

    // Coupons
    if (categoryTitle === "Coupons") {
      return <CouponsTab />;
    }

    if (categoryTitle === "Customer Engagement") {
      return <CustomerEngagementTab />;
    }

    // Default empty state
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          color: "#666",
        }}
      >
        <h3>Select a menu item to get started</h3>
      </div>
    );
  };

  return (
    <div
      style={{
        width: getContentWidth(),
        height: "calc(100vh - 8vh)", // Full height minus header
        minHeight: "calc(100vh - 60px)", // Account for min header height
        left: getContentLeft(),
        top: getContentTop(),
        position: "fixed",
        overflowY: "auto",
        overflowX: "hidden",
        padding: isMobile ? "16px" : "20px",
        background: "#f4f4f4",
        transition: "all 0.4s ease",
        zIndex: 1,
        // Add blur overlay when mobile sidebar is open
        filter: isMobile && isMobileSidebarOpen ? "brightness(0.6)" : "none",
        pointerEvents: isMobile && isMobileSidebarOpen ? "none" : "auto",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          width: "100%",
          paddingBottom: isMobile ? "40px" : "20px", // Extra padding on mobile for better scrolling
        }}
      >
        {renderContent()}
      </div>
    </div>
  );
};

export default Contents;
